import { render, staticRenderFns } from "./comp_ProductImagesThumb.vue?vue&type=template&id=70831ade&scoped=true&"
import script from "./comp_ProductImagesThumb.vue?vue&type=script&lang=js&"
export * from "./comp_ProductImagesThumb.vue?vue&type=script&lang=js&"
import style0 from "./comp_ProductImagesThumb.vue?vue&type=style&index=0&id=70831ade&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70831ade",
  null
  
)

export default component.exports